export const EXTERNAL_LINKS = {
  TERMS: 'https://www.christiedigital.com/about/terms-and-conditions/',
  POLICY: 'https://www.christiedigital.com/about/privacy-policy/',
  ABOUT: 'https://www.christiedigital.com/about/',
};
